module.exports = __webpack_public_path__ + "yeni ofis 2.jpg?38e40c791e97ccd95b2ad2194060a897";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni ofis 2.jpg
// module id = 390
// module chunks = 0